import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">2025 Copyright by Armonia House. All rights reserved.</div>
    </footer>
  );
}
